import { createApp } from "vue"
import ContactCardLeadWithoutPermission from "./ContactCard"
import { VueReCaptcha } from 'vue-recaptcha-v3'

const el = ".nyk-component--contact-card"

export default function (Store) {
    const DOM = document.querySelectorAll(el)
    if (DOM.length) {
        DOM.forEach((ContactCardLeadWithoutPermissionDOM) => {
            const recaptchaSiteKey = ContactCardLeadWithoutPermissionDOM.dataset.recaptchaSiteKey;

            const props = {
                labels: JSON.parse(ContactCardLeadWithoutPermissionDOM.dataset.labels),
                formId: ContactCardLeadWithoutPermissionDOM.dataset.id,
                formGuid: ContactCardLeadWithoutPermissionDOM.dataset.formGuid,
                formIdentifier: ContactCardLeadWithoutPermissionDOM.dataset.formId,
                antiForgeryToken: ContactCardLeadWithoutPermissionDOM.dataset.antiForgeryToken,
                formTypeName: ContactCardLeadWithoutPermissionDOM.dataset.formTypeName,
                apiUrl: ContactCardLeadWithoutPermissionDOM.dataset.apiUrl,
                newsletterApiUrl: ContactCardLeadWithoutPermissionDOM.dataset.newsletterApiUrl,
                newsletters: ContactCardLeadWithoutPermissionDOM.dataset.newsletters
                    ? JSON.parse(ContactCardLeadWithoutPermissionDOM.dataset.newsletters)
                    : [],
                alignIntroImageRight: ContactCardLeadWithoutPermissionDOM.dataset.alignIntroImageRight === "true",
                skipFirstStep: ContactCardLeadWithoutPermissionDOM.dataset.skipFirstStep === "true",
                imageSource: ContactCardLeadWithoutPermissionDOM.dataset.imageSource,
                backgroundColor: ContactCardLeadWithoutPermissionDOM.dataset.backgroundColor ?? null,
                assignTo: ContactCardLeadWithoutPermissionDOM.dataset.assignTo,
                enableUserTrack: ContactCardLeadWithoutPermissionDOM.dataset.enableUserTrack,
                anchorId: ContactCardLeadWithoutPermissionDOM.dataset.anchorId,
                alwaysShowCprField: ContactCardLeadWithoutPermissionDOM.dataset.alwaysShowCpr === "true",
            }
            const component = createApp(ContactCardLeadWithoutPermission, props)
                .use(Store)
                .use(VueReCaptcha, { siteKey: recaptchaSiteKey })
            component.mount(ContactCardLeadWithoutPermissionDOM)
        })
    }
}
